module.exports = __webpack_public_path__ + "images/FUSA_icons/094-gift.8c9c82e7b8ed7cecdec1c3d9651589af.svg";